import { useMutation } from "@tanstack/react-query";
import { withNamespaces } from "react-i18next";
import { toast } from "react-toastify";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from "reactstrap";
import ComplianceMonitoringService from "src/modules/3rd-party-management/apis/admin/compliance/monitoring/MonitoringService";

const MonitoringConfirmationModal = ({ t, supplierId, person, isOpen, toggle, onCompleted }) => {
    const handleStartMonitoring = useMutation({
        mutationFn: async (payload) => {
            const service = ComplianceMonitoringService.getInstance();

            return await service.addPersonToMonitoringList(payload);
        },
        onSuccess: () => {
            toast(
                t("Monitoring started successfully for the selected person."),
                {
                    type: 'success'
                }
            );
            onCompleted && onCompleted();
        },
        onError: ({ response }) => {
            const {
                data: errorData
            } = response || {};

            if (errorData?.error === 'insufficient_credit_kyb') {
                toast(t('Unable to start monitoring for this person due to insufficient KYB {{creditLabel}}. Please top up your balance and try again.', {
                    creditLabel: 'credit'
                }), {
                    type: "error"
                });
            }
            else {
                toast(t("Failed to start monitoring. Please try again or check the selected item."), {
                    type: "error"
                });
            }
        }
    });

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalHeader toggle={toggle}>
                {t('Confirm Start Monitoring')}
            </ModalHeader>

            <ModalBody>
                {t('Are you sure you want to start compliance monitoring for')}{" "}
                <strong>{person?.fullName}</strong>?
            </ModalBody>

            <ModalFooter>
                <Button color="secondary" onClick={toggle}>
                    {t('Cancel')}
                </Button>
                <Button
                    color="success"
                    disabled={handleStartMonitoring.isLoading}
                    onClick={() => {
                        handleStartMonitoring.mutate({
                            team_member_id: person?.id,
                            supplier_id: supplierId
                        });
                    }}
                >
                    {handleStartMonitoring.isLoading && (
                        <Spinner 
                            size="sm" 
                            color="light" 
                            className="me-2" 
                        />
                    )}

                    {t('Start Monitoring')}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default withNamespaces()(
    MonitoringConfirmationModal
);